"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FreshIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const FreshIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.856 3.89c.042 2.724.324 4.721.75 6.14.467 1.554 1.075 2.312 1.622 2.642.515.31 1.133.333 1.882.038.319-.126.65-.306.984-.534-.419-1.389-1.112-2.766-2.248-4.133a.85.85 0 1 1 1.308-1.086 13.407 13.407 0 0 1 2.328 4.023l.02-.02c.672-.706.905-1.502.825-2.305-.082-.826-.503-1.711-1.235-2.508C8.748 4.68 6.46 3.63 3.856 3.89Zm4.878 10.401c.254-.1.506-.222.755-.361.266 1.705.227 3.43.189 5.178-.014.627-.028 1.258-.028 1.892a.85.85 0 1 0 1.7 0c0-.574.015-1.165.03-1.771.051-2.012.106-4.185-.369-6.4.248-.22.49-.453.721-.696 1.02-1.068 1.415-2.357 1.287-3.647-.127-1.266-.75-2.482-1.674-3.489C9.5 2.985 6.331 1.665 2.843 2.321a.85.85 0 0 0-.693.835c0 3.19.299 5.6.828 7.363.527 1.753 1.315 2.971 2.373 3.609 1.092.657 2.292.594 3.383.163Zm7.55 1.51a.85.85 0 0 0-.567-1.602 5.588 5.588 0 0 0-1.692.93 1.6 1.6 0 0 1 .126-.736c.19-.46.603-.923 1.23-1.288 1.11-.647 2.784-.912 4.562-.324-1.057 3.414-2.488 4.185-3.409 4.26-.545.043-1.08-.129-1.519-.402a3.122 3.122 0 0 1-.078-.05c.333-.313.77-.584 1.347-.788Zm-2.218 2.25.052.032c.674.42 1.567.732 2.553.652 2.079-.167 3.99-1.971 5.123-6.245a.85.85 0 0 0-.471-.992c-2.504-1.132-5.05-.88-6.797.137-.872.508-1.58 1.23-1.945 2.104-.368.885-.36 1.875.119 2.826.02.05.044.099.069.148-.152.309-.27.626-.36.945-.307 1.097-.281 2.24-.265 2.97.003.14.006.265.006.372a.85.85 0 0 0 1.7 0c0-.156-.003-.318-.006-.485-.014-.736-.03-1.57.203-2.398l.019-.067Z"
}));
exports.FreshIcon = FreshIcon;